export function SET_CART_DATA(state, cartPayload) {
  const actualCartData =
    cartPayload && cartPayload.data ? cartPayload.data : cartPayload;

  if (actualCartData && actualCartData.id) {
    state.listings = actualCartData.items || [];
    state.cartId = actualCartData.id || null;
    state.userId = actualCartData.user_id || null;
    state.licenseId = actualCartData.license_id || null;
  } else {
    state.listings = [];
    state.cartId = null;
    state.userId = null;
    state.licenseId = null;
  }
  state.lastError = null;
}

export function SET_LOADING(state, isLoading) {
  state.isLoading = isLoading;
}

export function SET_ERROR(state, error) {
  state.lastError = error;
}

export function CLEAR_CART_STATE(state) {
  state.listings = [];
  state.cartId = null;
  state.userId = null;
  state.licenseId = null;
  state.isLoading = false;
  state.lastError = null;
  state.externalPoItems = [];
}

export function SET_SINGLE_ORDER_ITEM(state, item) {
  state.singleOrderItem = item;
  state.singleOrderMode = true;
}

export function CLEAR_SINGLE_ORDER(state) {
  state.singleOrderItem = null;
  state.singleOrderMode = false;
}

export function UPDATE_VENDOR_NOTE(state, { itemId, vendorNote }) {
  if (
    state.singleOrderMode &&
    state.singleOrderItem &&
    state.singleOrderItem.id === itemId
  ) {
    state.singleOrderItem.vendorNote = vendorNote;
  } else {
    const item = (state.listings || []).find((i) => i.id === itemId);
    if (item) item.vendorNote = vendorNote;
  }
}

export const REMOVE_CART_ITEMS = (state, itemIds) => {
  const idSet = new Set(itemIds);
  state.listings = (state.listings || []).filter((i) => !idSet.has(i.id));
  state.lastError = null;
};

export function UPSERT_EXTERNAL_PO_ITEM(state, item) {
  const normalizedAllocations = Array.isArray(item.allocations)
    ? item.allocations
        .map((allocation) => ({
          buyer_license_id: Number(
            allocation?.buyer_license_id || allocation?.license_id || 0
          ),
          qty_ordered: Number(
            allocation?.qty_ordered ?? allocation?.quantity ?? 0
          ),
        }))
        .filter((a) => a.buyer_license_id && a.qty_ordered > 0)
    : [];

  const normalized = {
    id: item.id,
    external_vendor_id: Number(item.external_vendor_id || 0),
    external_vendor_product_id: Number(item.external_vendor_product_id || 0),
    vendor_name: item.vendor_name || "Vendor",
    vendor_product_name: item.vendor_product_name || "Unnamed product",
    vendor_sku: item.vendor_sku || null,
    image: item.image || null,
    quantity: Math.max(1, Number(item.quantity || 1)),
    unit_type: item.unit_type || "unit",
    unit_label: item.unit_label || "unit",
    unit_cost: Number(item.unit_cost || 0),
    expected_date: item.expected_date || null,
    internal_notes: item.internal_notes || null,
    vendor_notes: item.vendor_notes || null,
    allocations: normalizedAllocations,
  };

  const idx = (state.externalPoItems || []).findIndex((i) => i.id === normalized.id);
  if (idx >= 0) {
    const current = state.externalPoItems[idx];
    const mergedAllocationsMap = {};
    [...(current.allocations || []), ...normalizedAllocations].forEach((a) => {
      const licenseId = Number(a?.buyer_license_id || 0);
      const qty = Number(a?.qty_ordered || 0);
      if (!licenseId || qty <= 0) return;
      mergedAllocationsMap[licenseId] =
        Number(mergedAllocationsMap[licenseId] || 0) + qty;
    });

    state.externalPoItems[idx] = {
      ...current,
      ...normalized,
      quantity: Math.max(1, Number(current.quantity || 0) + Number(normalized.quantity || 0)),
      allocations: Object.keys(mergedAllocationsMap).map((licenseId) => ({
        buyer_license_id: Number(licenseId),
        qty_ordered: Number(mergedAllocationsMap[licenseId] || 0),
      })),
    };
  } else {
    state.externalPoItems = [...(state.externalPoItems || []), normalized];
  }
}

export function UPDATE_EXTERNAL_PO_ITEM_QTY(state, { id, quantity }) {
  const idx = (state.externalPoItems || []).findIndex((i) => i.id === id);
  if (idx < 0) return;
  const nextQty = Math.max(1, Number(quantity || 1));
  state.externalPoItems[idx] = {
    ...state.externalPoItems[idx],
    quantity: nextQty,
  };
}

export function REMOVE_EXTERNAL_PO_ITEM(state, id) {
  state.externalPoItems = (state.externalPoItems || []).filter((i) => i.id !== id);
}

export function CLEAR_EXTERNAL_PO_ITEMS(state) {
  state.externalPoItems = [];
}
